import script from "./OrderStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderStatus.vue?vue&type=script&setup=true&lang=js"

import "./OrderStatus.vue?vue&type=style&index=0&id=7afeb184&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7afeb184"]])

export default __exports__